import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import AddEditType from "./AddEditMemberStatus";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { useTranslation } from "react-i18next";

const MemberStatus = () => {
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const [list, setList] = useState([]);
  const { branch, setLoader } = useContext(AppContext);
  const { t } = useTranslation();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("CfmTitle"),
      subTitle: t("MemberStatusDltTitle"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("DltSuccessTitle"),
              subTitle: res.msg,
            });
            setList((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("Warning"),
              subTitle: res.msg,
            });
          }
        };
        API(endpoints.MemberStatus).Delete(id, onComplete);
      },
    });
  };

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.MemberStatus + actions.GetAllByOrg).getById(
        branch.orgId,
        (res) => {
          res.status === 200 && setList([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(props)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddStatus")}</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: t("Name") },
          { id: "userName", label: t("AddedUser") },
          { id: "addDate", label: t("AddedDate") },
          { id: "updateDate", label: t("LastUpdateDate") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={list.map((j) => ({
          ...j,
          userName: j.addedUser && j.addedUser.firstName,
        }))}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditType
            {...{ setShowForm: setShowForm, updData, setAlert, setList }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default MemberStatus;
